import React, { useState, useEffect, useMemo } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import Breadcrums from "../../common/breadcrumbs";
import CustomPagination from "../../common/custompagination";
import Sorting from "../../common/sorting";
import Loader from "../../common/loader";
import { showFilterlist, SWAL_SETTINGS } from "../../../../utils/Constants";
import { formateDateWithMonth, handleServerValidations } from "../../../../utils/commonfunction";
import { DeleteRemedies, RemediesList, StatusRemedies, UpdateRemedyStock } from "../../services/remedise.services";
import { useTranslation } from "react-i18next";
import StatusFilter from "../../common/statusFilter";
import CustomRangepicker from "../../common/rangepicker";
import { Button, Modal } from "rsuite";
import { useFormik } from "formik";
import * as Yup from "yup";
import { FaPen } from "react-icons/fa"; // or any icon library
import { getAllServiceList } from "../../services/common.services";

const RemedyList = () => {
    const navigate = useNavigate();
    const params = useParams();
    const location = useLocation();

    const [list, setList] = useState([]);
    const [page, setPage] = useState(1);
    const [itemPerPage] = useState(10);
    const [sorting, setSorting] = useState({});
    const [loader, setLoader] = useState(true);
    const [totalRecords, setTotalRecords] = useState(0);
    const [globalSearch, setGlobalSearch] = useState("");
    const [resetdate, setResetDate] = useState(false);
    const [search, setSearch] = useState({});
    const [statsupdate, setStatusUpdate] = useState(false);
    const [selectedTab, setSelectedTab] = useState("all");
    const { t } = useTranslation();
    const [showStockModal, setShowStockModal] = useState(false);
    const [editingRemedyId, setEditingRemedyId] = useState(null);
    const [stockInitialValue, setStockInitialValue] = useState("");
    const [remedyTypeList, setRemedyTypeList] = useState([]);

    const breadcrumbs = [
        { title: "Dashboard", url: "/admin/dashboard" },
        { title: "Remedies", url: "" },
    ];

    useEffect(() => {
        const fetchData = setTimeout(() => {
            setLoader(true);
            const formData = new FormData();
            formData.append("page", params.pgno || page);
            formData.append("per_page", itemPerPage);
            formData.append("sort", JSON.stringify(sorting));
            formData.append("search", JSON.stringify(search));
            formData.append("global_search", globalSearch);
            formData.append("remedy_type", selectedTab === "all" ? "" : selectedTab);
            // formData.append("attributes", JSON.stringify({ caret: 20 }));

            // setList(DUMMY_REMEDIES); // Using dummy data for testing
            // setTotalRecords(DUMMY_REMEDIES.length); // Using dummy data for testing

            RemediesList(formData)
                .then((response) => {
                    setList(response.data?.list || []);
                    setTotalRecords(response.data?.total_records || 0);
                    setLoader(false);
                })
                .catch(() => {
                    setLoader(false);
                });
            // setLoader(false);
        }, 300);

        return () => clearTimeout(fetchData);
    }, [page, itemPerPage, sorting, globalSearch, params.pgno, location, statsupdate, search, selectedTab]);

    const remedyTypeMap = useMemo(() => {
        const map = {};
        remedyTypeList.forEach((type) => {
            map[type._id] = type.title; 
        });
        // Optional: Add fallback for hardcoded ones if needed
        map["gemstone"] = "Gemstone";
        map["rudraksha"] = "Rudraksha";
        map["puja"] = "Puja"; // or "Online Puja" depending on your data
        map["yantra"] = "Yantra";
        return map;
    }, [remedyTypeList]);

    useEffect(() => {
        getAllServiceList("remedies").then((response) => {
            setRemedyTypeList(response.data || []);
        }).catch((error) => {
            console.log(error);
        });
    }, []);

    const handleSort = (e, column) => {
        const order = e.target.classList.contains("asc") ? -1 : 1;
        setSorting({ column, order });
    };

    const prepareSearch = (key, value) => {
        let sr = { ...search };
        if (String(value).length > 0) {
            sr[key] = value;
        } else {
            delete sr[key];
        }
        setSearch(sr);
    };

    const resetFilter = (e) => {
        e.preventDefault();
        setGlobalSearch("");
        prepareSearch();
        setSearch({});
        setResetDate(!resetdate);
        // $("#defaultstatus")[0].selectedIndex = 0;
    };

    const viewRemedy = (row) => {
        navigate(`/admin/remedies-management/remedies/view/${row._id}`);
    };

    const deleteRemedy = (id) => {
        Swal.fire({
            customClass: "swal-wide",
            title: t("msg_are_you_sure"),
            text: t("you_not_be_able_to_revert_this"),
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#403fad",
            cancelButtonColor: "#f1388b",
            confirmButtonText: t("btn_yes_delete"),
            cancelButtonText: t("btn_cancel"),
        }).then((result) => {
            if (result.isConfirmed) {
                DeleteRemedies(id)
                    .then((response) => {
                        if (response.success) {
                            Swal.fire({
                                icon: "success",
                                text: response.message,
                                ...SWAL_SETTINGS,
                            });
                            setList(list.filter((l) => l._id !== id));
                            setTotalRecords((prev) => prev - 1);
                        } else {
                            Swal.fire({
                                icon: "error",
                                text: handleServerValidations(response),
                                ...SWAL_SETTINGS,
                            });
                        }
                    })
                    .catch(() => {
                        Swal.fire({ icon: "error", text: "Network or server error" });
                    });
            }
        });
    };

    const ChangeStatus = (data, Num) => {
        let ids = Array.isArray(data) ? data : [data];
        const formData = new FormData();
        formData.append("o_id", JSON.stringify(ids));
        formData.append("status", Num);
        Swal.fire({
            customClass: "swal-wide",
            title: t(`Are you sure you want to ${Num === 0 ? "inactive" : "active"} this Remedy ?`),
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#403fad",
            cancelButtonColor: "#f1388b",
            confirmButtonText: t("btn_yes"),
            cancelButtonText: t("btn_cancel"),
        }).then((result) => {
            if (result.isConfirmed) {
                StatusRemedies(formData)
                    .then((response) => {
                        if (response.success) {
                            Swal.fire({
                                icon: "success",
                                text: response.message,
                                ...SWAL_SETTINGS,
                            });
                            setStatusUpdate(!statsupdate);
                        } else {
                            Swal.fire({
                                icon: "error",
                                text: handleServerValidations(response),
                                ...SWAL_SETTINGS,
                            });
                        }
                    })
                    .catch((error) => {
                        console.log("error===>");
                    });
            }
        });
    };

    const openStockModal = (remedy) => {
        setEditingRemedyId(remedy._id);
        setStockInitialValue(remedy.stock || "");
        setShowStockModal(true);
        stockFormik.setValues({ stock: remedy.stock || "" }, false); // reset formik values on open
    };

    const closeStockModal = () => {
        setShowStockModal(false);
        setEditingRemedyId(null);
        setStockInitialValue("");
        stockFormik.resetForm();
    };

    const stockFormik = useFormik({
        initialValues: {
            stock: "",
        },
        enableReinitialize: true, // allow resetting when initialValues change
        validationSchema: Yup.object({
            stock: Yup.number().min(0, "Stock must be at least 0").max(10000, "Stock must be at most 10000").integer("Stock must be an integer").required("Stock is required"),
        }),
        onSubmit: (values, { setSubmitting, resetForm }) => {
            if (!editingRemedyId) {
                setSubmitting(false);
                return;
            }

            const formData = {
                o_id: editingRemedyId,
                stock: values.stock,
            };

            UpdateRemedyStock(formData)
                .then((response) => {
                    if (response.success) {
                        Swal.fire({
                            icon: "success",
                            text: response.message,
                            ...SWAL_SETTINGS,
                        });
                        resetForm();
                        closeStockModal();
                        setStatusUpdate((prev) => !prev); // refresh list
                    } else {
                        Swal.fire({
                            icon: "error",
                            text: handleServerValidations(response),
                            ...SWAL_SETTINGS,
                        });
                    }
                })
                .catch((error) => {
                    console.log("Error changing stock:", error);
                    Swal.fire({
                        icon: "error",
                        text: "An unexpected error occurred",
                        ...SWAL_SETTINGS,
                    });
                })
                .finally(() => {
                    setSubmitting(false);
                });
        },
    });

    return (
        <>
            <Breadcrums data={breadcrumbs} />
            <div className="card custom-card">
                <div className="card-body">
                    <div className="d-flex justify-content-between align-items-center mb-4">
                        <h6 className="main-content-label">Remedies</h6>
                        <div className="d-flex align-items-center">
                            <div className="form-group mb-0 me-3">
                                <div className="form-group mb-0 rangepicker_container filter_design">
                                    <i className="fa fa-search calender_icon"></i>
                                    <input
                                        type="search"
                                        className="form-control"
                                        value={globalSearch}
                                        placeholder="Search"
                                        onChange={(e) => {
                                            setGlobalSearch(e.target.value);
                                        }}
                                    />
                                </div>
                            </div>
                            <div className="me-3">
                                <CustomRangepicker
                                    GetDateRange={(e) => {
                                        prepareSearch("createdAt", e);
                                    }}
                                    resetdate={resetdate}
                                />
                            </div>
                            <div className="me-3">
                                <StatusFilter className="cp" data={showFilterlist} prepareSearch={prepareSearch} />
                            </div>
                            <button type="reset" value="Reset" onClick={resetFilter} className="btn btn-warning float-right mr-2">
                                Reset
                            </button>
                            <button className="btn ripple btn-main-primary signbtn" onClick={() => navigate(`/admin/remedies-management/remedies/add`)}>
                                Add Remedy
                            </button>
                        </div>
                    </div>
                    {/* <div className="mb-3">
                        <button className={`btn btn-sm me-2 ${selectedTab === "all" ? "btn-primary" : "btn-outline-primary"}`} onClick={() => setSelectedTab("all")}>
                            All
                        </button>
                        <button className={`btn btn-sm me-2 ${selectedTab === "gemstone" ? "btn-primary" : "btn-outline-primary"}`} onClick={() => setSelectedTab("gemstone")}>
                            Gemstone
                        </button>
                        <button className={`btn btn-sm me-2 ${selectedTab === "rudraksha" ? "btn-primary" : "btn-outline-primary"}`} onClick={() => setSelectedTab("rudraksha")}>
                            Rudraksha
                        </button>
                        <button className={`btn btn-sm me-2 ${selectedTab === "puja" ? "btn-primary" : "btn-outline-primary"}`} onClick={() => setSelectedTab("puja")}>
                            Puja
                        </button>
                        <button className={`btn btn-sm me-2 ${selectedTab === "yantra" ? "btn-primary" : "btn-outline-primary"}`} onClick={() => setSelectedTab("yantra")}>
                            Yantra
                        </button>
                    </div> */}
                    <div className="mb-3">
                        <button
                            className={`btn btn-sm me-2 ${selectedTab === "all" ? "btn-primary" : "btn-outline-primary"}`}
                            onClick={() => setSelectedTab("all")}
                        >
                            All
                        </button>

                        {remedyTypeList.map((type) => (
                            <button
                                key={type._id}
                                className={`btn btn-sm me-2 ${selectedTab === type._id ? "btn-primary" : "btn-outline-primary"}`}
                                onClick={() => setSelectedTab(type._id)} // Now using _id instead of slug
                            >
                                {type.title}
                            </button>
                        ))}
                    </div>
                    <div className="table-responsive">
                        <table className="table table-bordered border-t0 key-buttons text-nowrap w-100">
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Image</th>
                                    <th>
                                        <div className="sorting_column">
                                            <span>Name</span>
                                            <Sorting sort={sorting} handleSort={handleSort} column="name" />
                                        </div>
                                    </th>
                                    <th>Type</th>
                                    <th>Status</th>
                                    <th>Stock</th>
                                    <th>Price</th>
                                    <th>Delivery Charge</th>
                                    <th>Rating</th>
                                    <th>
                                        <div className="sorting_column">
                                            <span>Created At</span>
                                            <Sorting sort={sorting} handleSort={handleSort} column="createdAt" />
                                        </div>
                                    </th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {loader ? (
                                    <tr>
                                        <td colSpan={12}>
                                            <Loader />
                                        </td>
                                    </tr>
                                ) : list.length > 0 ? (
                                    list.map((remedy, i) => (
                                        <tr key={remedy._id}>
                                            <td>{(page - 1) * itemPerPage + i + 1}</td>
                                            {/* <td>
                                                <div className="row_image">
                                                    <img className="rounded" alt="Remedy" src={remedy?.image} />
                                                </div>
                                            </td> */}
                                            {/* Remedy Image */}
                                            <td>
                                            <div className="d-flex justify-content-center">
                                                <img className="img-fluid rounded" alt="Remedy" src={remedy?.image} style={{ maxWidth: "50px" }} />
                                            </div>
                                            </td>
                                            <td>{remedy.name}</td>
                                            <td>
                                                {remedyTypeMap[remedy.remedy_type] || "Unknown Type"}
                                            </td>
                                            <td>
                                                {remedy.status === 1 ? (
                                                    <button
                                                        className="btn ripple btn-main-primary signbtn"
                                                        onClick={() => {
                                                            ChangeStatus(remedy?._id, 0);
                                                        }}
                                                    >
                                                        {t("btn_active")}
                                                    </button>
                                                ) : (
                                                    <button
                                                        className="btn ripple btn-secondary"
                                                        onClick={() => {
                                                            ChangeStatus(remedy._id, 1);
                                                        }}
                                                    >
                                                        {t("btn_inactive")}
                                                    </button>
                                                )}
                                            </td>
                                            {/* <td>
                                                <div className="d-flex flex-column align-items-center p-2 border rounded" style={{ minWidth: 90 }}>
                                                    <span style={{ fontWeight: "bold", fontSize: "1.1em" }}>{remedy.stock || 0}</span>
                                                    <button className="btn btn-sm btn-secondary mt-1" onClick={() => openStockModal(remedy)}>
                                                        Edit Stock
                                                    </button>
                                                </div>
                                            </td> */}
                                            {/* <td>
                                                <div className="d-flex align-items-center" style={{ minWidth: "90px" }}>
                                                    <span
                                                        className="me-2 text-end fw-bold"
                                                        style={{
                                                            width: "50px",
                                                            fontVariantNumeric: "tabular-nums",
                                                            display: "inline-block",
                                                        }}
                                                    >
                                                        {remedy.stock || 0}
                                                    </span>
                                                    <button
                                                        type="button"
                                                        className="btn btn-sm btn-outline-secondary d-flex align-items-center justify-content-center"
                                                        style={{ width: "28px", height: "28px", padding: 0 }}
                                                        onClick={() => openStockModal(remedy)}
                                                        title="Edit Stock"
                                                    >
                                                        <FaPen />
                                                    </button>
                                                </div>
                                            </td> */}
                                             {/* Stock and Edit Stock */}
                                           {/* Stock Column - 3 Fixed Sections (Alert | Stock Number | Edit Button) */}
                                           <td className="py-3">
                                            {/* Completely hide entire cell content for Online Puja */}
                                            {remedyTypeMap[remedy.remedy_type] === "Online Puja" || remedyTypeMap[remedy.remedy_type] === "Online Pooja" ? (
                                                <div className="text-center text-muted">
                                                <small>— Not Applicable —</small>
                                                </div>
                                            ) : (
                                                <div className="d-flex align-items-center justify-content-center gap-4">

                                                {/* Section 1: Low Stock Alert - Only if stock exists and < 5 */}
                                                <div style={{ width: '50px', textAlign: 'center' }}>
                                                    {remedy.stock != null && remedy.stock < 5 ? (
                                                    <span className="badge bg-danger text-white px-2 py-1 rounded-pill fs-6">
                                                        LOW
                                                    </span>
                                                    ) : (
                                                    <span style={{ visibility: 'hidden' }}>LOW</span>
                                                    )}
                                                </div>

                                                {/* Section 2: Stock Number */}
                                                <div className="text-center" style={{ minWidth: '70px' }}>
                                                    <div
                                                    className={`fw-bold ${
                                                        remedy.stock === 0
                                                        ? 'text-danger'
                                                        : remedy.stock < 5
                                                        ? 'text-warning'
                                                        : 'text-success'
                                                    }`}
                                                    style={{
                                                        fontSize: '1.2rem',
                                                        fontVariantNumeric: 'tabular-nums'
                                                    }}
                                                    >
                                                    {remedy.stock ?? 0}
                                                    </div>
                                                    {remedy.stock === 0 && (
                                                    <small className="text-muted d-block" style={{ marginTop: '-3px', fontSize: '0.7rem' }}>
                                                        Out of stock
                                                    </small>
                                                    )}
                                                </div>

                                                {/* Section 3: Edit Button - Always shown (unless online_puja) */}
                                                <div>
                                                    <button
                                                    type="button"
                                                    className="btn btn-primary signbtn rounded-circle d-flex align-items-center justify-content-center shadow-sm"
                                                    style={{ width: '36px', height: '36px', padding: 0 }}
                                                    onClick={() => openStockModal(remedy)}
                                                    title="Update Stock"
                                                    >
                                                    <i className="fas fa-pen text-white fs-6"></i>
                                                    </button>
                                                </div>

                                                </div>
                                            )}
                                            </td>
                                            {/* Price and Discounted Price */}
                                            <td>
                                            <div>
                                                {remedy.discount ? (
                                                <div>
                                                    <span
                                                    style={{
                                                        textDecoration: "line-through",
                                                        color: "#888",
                                                        marginRight: "8px",
                                                    }}
                                                    className="text-muted"
                                                    >
                                                    ₹{remedy.price.toFixed(2)}
                                                    </span>
                                                    <span style={{ color: "red", fontWeight: "bold" }}>
                                                    ₹{(remedy.price - (remedy.price * remedy.discount) / 100).toFixed(2)}
                                                    </span>
                                                </div>
                                                ) : (
                                                <span>₹{remedy.price.toFixed(2)}</span>
                                                )}
                                            </div>
                                            </td>
                                            {/* Delivery Charge */}
                                            <td>
                                                <span>₹{(remedy.delivery_charge || 0).toFixed(2)}</span>
                                            </td>
                                            {/* Rating */}
                                            <td>
                                           <div>
                                                {[1, 2, 3, 4, 5].map((star) => {
                                                    const displayRating = remedy.rating && remedy.rating > 0
                                                        ? remedy.rating                      // Admin rating
                                                        : remedy.average_rating || 0;         // User average rating

                                                    return (
                                                        <i
                                                            key={star}
                                                            className={`fas fa-star ${
                                                                displayRating >= star ? "text-warning" : "text-muted"
                                                            }`}
                                                        />
                                                    );
                                                })}
                                            </div>
                                            </td>
                                            <td>{formateDateWithMonth(remedy.createdAt)}</td>
                                            <td>
                                                <button className="btn ripple btn-main-primary signbtn me-2" onClick={() => viewRemedy(remedy)}>
                                                    View
                                                </button>
                                                <button className="btn btn-info me-2" onClick={() => navigate(`/admin/remedies-management/remedies/edit/${remedy._id}`)}>
                                                    Edit
                                                </button>
                                                <button className="btn btn-danger" onClick={() => deleteRemedy(remedy._id)}>
                                                    Delete
                                                </button>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan={12} className="text-center">
                                            No records found
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                    <div className="" id="example1_info" role="status" aria-live="polite">
                        <b>
                            {t("msg_total_records")} : {totalRecords ? totalRecords : "0"}
                        </b>
                    </div>
                    {totalRecords > 0 && (
                        <CustomPagination
                            datalength={totalRecords}
                            itemperpage={itemPerPage}
                            currentPage={page}
                            setPage={setPage}
                            pageRoute={[{ name: "Remedies", path: "/admin/remedies-management/remedies/list" }]}
                        />
                    )}
                </div>
            </div>
            {/* Stock Modal */}
            <Modal open={showStockModal} onClose={closeStockModal} backdrop="static" keyboard={false} size="sm">
                <Modal.Header>
                    <Modal.Title>Update Stock</Modal.Title>
                </Modal.Header>

                <form onSubmit={stockFormik.handleSubmit}>
                    <Modal.Body>
                        <div className="form-group mb-3">
                            <label htmlFor="stock">Stock</label>
                            <input
                                type="number"
                                id="stock"
                                name="stock"
                                className={`form-control ${stockFormik.touched.stock && stockFormik.errors.stock ? "is-invalid" : ""}`}
                                value={stockFormik.values.stock}
                                onChange={stockFormik.handleChange}
                                onBlur={stockFormik.handleBlur}
                                autoFocus
                                min={0}
                                step={1}
                                required
                            />
                            {stockFormik.touched.stock && stockFormik.errors.stock ? <div className="invalid-feedback">{stockFormik.errors.stock}</div> : null}
                        </div>
                    </Modal.Body>

                    <Modal.Footer>
                        <Button appearance="subtle" onClick={closeStockModal} disabled={stockFormik.isSubmitting}>
                            Cancel
                        </Button>
                        <Button type="submit" appearance="primary" disabled={stockFormik.isSubmitting}>
                            {stockFormik.isSubmitting ? "Saving..." : "Save Changes"}
                        </Button>
                    </Modal.Footer>
                </form>
            </Modal>
        </>
    );
};

export default RemedyList;
